import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { formatters as dateFormatters } from 'utils/dateAndTimes';
import { joinElementsWithSeparatorAndEndingSeparator } from 'utils/array';
import { selectors as orderSelector, selectorsByType } from 'state/order';
import Header from 'components/Recurring/Header/component';
import { getFirstDate } from 'utils/recurringOrder/recurringOrderUtils';

const getData = (state) => {
  const typeOfOrder = orderSelector.getTypeOfOrder(state);
  return {
    days: selectorsByType.days[typeOfOrder].getDays(state),
    start_from: selectorsByType.range[typeOfOrder].getRangeFrom(state),
    end_on: selectorsByType.range[typeOfOrder].getRangeTo(state),
  };
};

const enhance = compose(
  withTranslation('Recurring'),
  connect((state) => getData(state), {}),
  withProps(({ days, t, start_from, end_on }) => {
    const daysJoined = joinElementsWithSeparatorAndEndingSeparator(
      (days || []).sort().map((d) => t(`Recurring:weekdays_plural.${d}`)),
      ', ',
      t('Recurring:and')
    );
    const fromDate = dateFormatters.getHumanReadableFormattedDate({
      value: start_from,
      t,
    });
    const toDate = dateFormatters.getHumanReadableFormattedDate({
      value: end_on,
      t,
    });
    const firstDate = getFirstDate({ days, fromDate: start_from });
    const firstDateStr = dateFormatters.getHumanReadableFormattedDate({
      value: firstDate,
      t,
    });

    return {
      title: `${t('summary.repeat')} ${daysJoined}`,
      info: `${t('summary.from_to', { start: fromDate, end: toDate })} ${t(
        'summary.first',
        {
          first: firstDateStr,
        }
      )}.`,
      holidaysInfo: t('summary.holidays_info'),
    };
  })
);

export default enhance(Header);
